import React from "react";
import './footer.scss';
import imageFDIC from '../../assets/images/fdic.png';
import imageBBB from '../../assets/images/BBB.png';
import imageNorton from '../../assets/images/norton.png';
import imageRSA from '../../assets/images/rsa.png';

const getPrivacyLink = () => {
  if(window.isToggleOn('cl_update_privacy_link')) {
    return (window.location.hostname === 'loans.barclaysus.com' || window.location.hostname === 'prod-clapply-alpha-9540.barclaycardus.com' || window.location.hostname === 'apply.mybarclaycardloan.com') ? 'https://cards.barclaycardus.com/banking/privacy-policy/': 'https://qa01-cards.barclaycardus.com/banking/privacy-policy/';
  }
  return 'https://loans.barclaysus.com/privacy-policy.html';
};

export const Footer = ({ showRewardsLink, hideFooterIcons, hideBankName }) => {
  const privacyPolicyLink = getPrivacyLink();
  const securityPolicyLink = '/clapply/cyr/security-policy.html';
  const contactUsLink = 'http://loans.barclaysus.com/contact-us.html';
  const nortonBadgeLink = 'https://trustsealinfo.verisign.com/splash?form_file=fdf/splash.fdf&dn=www.barclaysus.com&lang=en';
  const bankName = '2019 Barclays Bank Delaware';
  const rewardsDetailsLink='/clapply/cyr/reward-disclosure.html';

  return (
    <footer className="footer">
      <div className="container p-4">
        <div className="row">
          <div className="col-12 col-sm-6">
            <small>
              <a id="privacy-policy" href={ privacyPolicyLink } target="_blank" className="text-muted sm-text">Privacy statement</a>
              &nbsp;|&nbsp;
              <a id="security-policy" href={ securityPolicyLink } target="_blank" className="text-muted sm-text">Security policy</a>
              &nbsp;|&nbsp;
              { (showRewardsLink) && <span><a id="rewards-details" href={rewardsDetailsLink} target="_blank" className="text-muted sm-text">Rewards details</a>
                  &nbsp;|&nbsp; </span> }
              <a id="contact-us" href={ contactUsLink } target="_blank" className="text-muted sm-text">Contact us</a>
            </small>
          </div>
          { (!hideFooterIcons) && <div className="col-12 col-md-6 text-right">
            <div className="d-flex justify-content-end">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <a href="https://www.fdic.gov/"
                    target="_blank">
                    <img src={imageFDIC} alt="FDIC badge"/>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="http://www.bbb.org/delaware/business-reviews/banks/barclays-bank-delaware-in-wilmington-de-22002677"
                    target="_blank">
                    <img src={imageBBB} alt="Better Business Bureau badge"/>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a id="norton-badge" href={ nortonBadgeLink } target="_blank">
                    <img src={imageNorton} alt="Norton badge"/>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.rsa.com/en-us" target="_blank">
                    <img src={imageRSA} alt="RSA badge"/>
                  </a>
                </li>
              </ul>
            </div>
          </div> }
        </div>
        { (!hideBankName) && <div className="row">
          <div className="col-12 text-right">
            <small id="bank-name" className="sm-text">© {bankName}, Member FDIC</small>
          </div>
        </div> }
      </div>
    </footer>);
};

export default Footer;
